var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactiveZoning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "#ffffff00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 28V4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E98",
    strokeDasharray: "3 3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.77258 4v24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    d: "M26.7027 4H5.2973C4.5808 4 4 4.5808 4 5.2973v21.4054C4 27.4192 4.5808 28 5.2973 28h21.4054C27.4192 28 28 27.4192 28 26.7027V5.2973C28 4.5808 27.4192 4 26.7027 4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveZoning);
export default __webpack_public_path__ + "static/media/InactiveZoning.d9a46393237d4584b2b0a2cea49561f0.svg";
export { ForwardRef as ReactComponent };